
import React from 'react'
import R from 'ramda'
import MoreMenu from '@vimcar/shared-components/components/MoreMenu'

import styles from './styles.css'

const init = () => ({})

const view = ({ menuItems, ...props }) => (component, cell) => (
  <MoreMenu
    menuItems={menuItems(cell.row)}
    size={18}
    {...props}
    />
)

export const menuable = (options) => ({
  name: 'menuable',
  init,
  update: () => ([columns, rows]) => [
    R.append({
      property: 'menuable',
      header: {
        props: {
          style: { flex: '0 0 auto', paddingLeft: '42px' },
        },
        label: '',
      },
      cell: {
        props: {
          className: styles.cell,
          style: { flex: '0 0 auto', paddingLeft: '6px' },
        },
        transforms: [view(options)],
      },
    }, columns),
    rows,
  ],
})
